import { defineSlotRecipe } from '@chakra-ui/react'

/** Width of the accent stripe rendered beside a dialog that has an icon. */
const ACCENT_STRIPE_WIDTH = '16'

export const dialogRecipe = defineSlotRecipe({
  slots: [
    'trigger',
    'backdrop',
    'positioner',
    'content',
    'header',
    'body',
    'footer',
    'title',
    'description',
    'closeTrigger',
    'accent',
  ],
  base: {
    backdrop: {
      bg: 'blackAlpha.300',
      backdropFilter: 'blur({blurs.md})',
    },
    content: {
      borderRadius: 'l3',
      overflow: 'hidden',
    },
    // Content stacked inside the dialog body, like any other block.
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'stack',
    },
    title: {
      textStyle: 'featureTitle',
    },
    accent: {
      display: 'none',
    },
  },
  variants: {
    /**
     * Renders a full-height accent stripe on the leading edge of the dialog with
     * the icon centred in it. The stripe takes its color from `colorPalette`, so
     * a dialog selects its state the same way every other component does.
     */
    accented: {
      true: {
        content: {
          paddingInlineStart: ACCENT_STRIPE_WIDTH,
        },
        accent: {
          display: 'flex',
          // Top-aligned rather than centred, so the icon stays level with the
          // title instead of drifting to the middle of a tall dialog. The top
          // padding matches the dialog header's own, and the icon is centred
          // within the title's line height, so it lines up with the first line
          // whatever size that title is.
          alignItems: 'flex-start',
          justifyContent: 'center',
          paddingBlockStart: '6',
          '& > svg': {
            boxSizing: 'content-box',
            blockSize: '2rem',
            paddingBlock: 0,
          },
          position: 'absolute',
          insetInlineStart: 0,
          insetBlock: 0,
          width: ACCENT_STRIPE_WIDTH,
          // A gradient fading into the dialog's own background, so the stripe
          // reads as an accent rather than a block competing with the text.
          bgGradient: 'to-r',
          gradientFrom: 'colorPalette.subtle',
          gradientTo: 'bg.panel',
          color: 'colorPalette.solid',
          flexShrink: 0,
        },
      },
    },
  },
  defaultVariants: {
    placement: 'center',
  },
})
